import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Awwwards-style momentum scrolling.
 *
 * - Uses lenis for smooth easing with a slight overshoot on wheel input.
 * - Automatically disabled for users with prefers-reduced-motion.
 * - Also disabled on touch/small-viewport so mobile keeps native inertia.
 * - Hooks framer-motion's window scroll listeners (they read window.scrollY,
 *   which lenis proxies correctly).
 */
export default function SmoothScroll() {
    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const smallScreen = window.matchMedia("(max-width: 768px)").matches;
        if (reduced || smallScreen) return;

        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.5,
        });

        let raf = 0;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        // Hash-link support (nav anchors)
        const handleAnchor = (e) => {
            const a = e.target.closest && e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href").slice(1);
            if (!id) return;
            const target = document.getElementById(id);
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -80, duration: 1.4 });
            }
        };
        document.addEventListener("click", handleAnchor);

        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", handleAnchor);
            lenis.destroy();
        };
    }, []);

    return null;
}
